import { DisplayUser } from '../../api-models';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import Role, { HTTPMethod } from '../../types/enums';
import { DisplayOrganisationUser } from '../../types/core.type';

export default class GetOrganisationUsers extends BaseAdapter<DisplayUser[]> implements AdapterInterface {
  rawResponse: DisplayUser[];

  async adaptResponse(): Promise<DisplayOrganisationUser[]> {
    await this.fetchApiResponse('/api/organisation-users', HTTPMethod.Get);
    return this.rawResponse.map((user: DisplayUser) => ({
      firstName: user.first_name,
      lastName: user.last_name,
      role: user.role as Role,
      email: user.email,
    }));
  }
}
